module.exports = __webpack_public_path__ + "img/logo_full_inviv.fec457c0.png";